import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

export default function AboutPage() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentHeadshot,
    getCurrentAbout,
  } = useUserParams();

  const agentName = getCurrentAgentName();
  const agentTitle = getCurrentAgentTitle();
  const agentNumber = getCurrentAgentNumber();
  const agentEmail = getCurrentAgentEmail();
  const brokerage = getCurrentBrokerage();
  const headshot = getCurrentHeadshot();
  const aboutText = getCurrentAbout() || constants.ABOUT_DESCRIPTION;

  return (
    <section
      className="relative w-full min-h-[100vh] flex items-center justify-center overflow-hidden pt-40 bg-cover"
      style={{
        backgroundImage: `url(${constants.ABOUT_BG_IMAGE})`,
      }}
    >
      <div
        className="max-w-[1100px] mx-auto gap-x-24 gap-y-12 px-6 grid sm:grid-cols-2 my-12 z-10 rounded-2xl p-10 shadow-xl backdrop-blur-lg"
        style={{
          background: constants.NIGHT_THEME_COLORS.card,
          border: `1.5px solid ${constants.NIGHT_THEME_COLORS.border}`,
          boxShadow: `0 4px 32px 0 ${constants.NIGHT_THEME_COLORS.accent}22`,
          animation: `fadeInUp ${constants.ANIMATION_CONFIG.cardFadeIn}s cubic-bezier(.4,2,.6,1) both`,
        }}
      >
        {/* Left: Headshot and info */}
        <div className="flex flex-col items-center">
          <div
            className="rounded-full overflow-hidden shadow-2xl mb-6 border-4"
            style={{
              borderColor: constants.NIGHT_THEME_COLORS.accent,
              boxShadow: `0 0 32px 0 ${constants.NIGHT_THEME_COLORS.accent}99`,
              transition: "box-shadow 0.3s",
            }}
          >
            <img
              src={headshot}
              alt={agentName}
              width={260}
              height={260}
              className="w-64 h-64 object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="flex flex-col gap-y-2 text-center">
            <h2
              className="text-3xl font-bold"
              style={{ color: constants.NIGHT_THEME_COLORS.text }}
            >
              {agentName}
            </h2>
            <p
              className="italic text-lg"
              style={{ color: constants.NIGHT_THEME_COLORS.secondaryText }}
            >
              {agentTitle}, {brokerage}
            </p>
            {/* Social icons with glow and hover effect */}
            <div className="flex gap-x-5 my-2 justify-center">
              {Object.entries(constants.SOCIALS)?.map(([key, value]) => (
                <a
                  key={key}
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-transform duration-200 hover:scale-125"
                  style={{
                    filter: constants.ANIMATION_CONFIG.iconGlow
                      ? `drop-shadow(${constants.ANIMATION_CONFIG.iconGlowBlur})`
                      : undefined,
                  }}
                >
                  <FontAwesomeIcon
                    className="fa-xl"
                    icon={constants.ICONS[key]}
                    style={{ color: "white" }}
                  />
                </a>
              ))}
            </div>
            <p
              className="font-semibold text-lg"
              style={{ color: constants.NIGHT_THEME_COLORS.text }}
            >
              {agentNumber}
            </p>
            <p
              className="text-lg"
              style={{ color: constants.NIGHT_THEME_COLORS.secondaryText }}
            >
              {agentEmail}
            </p>
          </div>
        </div>
        {/* Right: About card with glassmorphism */}
        <div className="flex flex-col justify-center">
          <h1
            className="text-4xl font-mont pb-8 font-bold"
            style={{
              color: constants.NIGHT_THEME_COLORS.text,
              textShadow: `0 0 16px white, 0 0 32px white`,
            }}
          >
            {constants.ABOUT_TITLE}
          </h1>
          <p style={{ color: constants.NIGHT_THEME_COLORS.text }}>{aboutText}</p>
        </div>
      </div>
      {/* Fade-in animation keyframes */}
      <style jsx>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(40px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
